<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CardPopupImg
        :cardContent="content"
        :cardType="cardType2"
        :isModalVisible="isShow"
        @updateUser="updateUser"
      />
    </template>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import CardPopupImg from './components/CardPopupImg.vue';
import '../../../assets/scss/_chineseModalCustom.scss';
import '../../../assets/scss/_chineseStyle.scss';
import LoadingMDL from '../../../components/loading/LoadingMDL';

export default {
  components: {CardPopupImg, LoadingMDL},
  name: 'LKI01',
  data() {
    return {
      code: '',
      lang: '',
      content: {},
      cardType2: 'img',
      isShow: true,
      CheckWidth: window.innerWidth.toString(),
      baseUrl: process.env.VUE_APP_URL_SOUND,
      sound: '',
      courseSection: '',
      startTime: '',
      courseCode: '',
      condition: [],
      navigate: {},
      loading: true,
      v3Data: {},
    };
  },

  computed: {
    ...mapGetters({
      getTemplatev3: 'v3/getTemplates',
    }),
  },

  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      this.content = val.templates[0];
      this.navigate = val.templates[0].content.item[0].navigate;

      if (!this.content.enable) {
        const pathFormat = this.content.navigate.close.action.split('-');
        alert('Access denied!');
        this.$router.push(`/v3/${pathFormat[0]}/${pathFormat[1]}`);
      }

      this.checkNull();
      this.checkPicture();

      // this.$store.dispatch('v3/v3FilterParent', val.codeItem);

      this.loading = false;
    },
  },

  mounted() {
    this.onLoad();
  },

  created() {},
  beforeDestroy() {},
  methods: {
    onLoad() {
      this.lang = this.$store.state.language.language;
      this.courseCode = this.$store.state.necessary.learningCourse;
      this.startTime = this.$helpers.getDateFormat();

      const contentId = `LKI01-${this.$route.params.id}`;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);
    },
    checkNull() {
      var data = this.content.content.item[0].title[0].value;
      if (data) {
        this.cardType2 = 'text';
      } else {
        this.cardType2 = 'img';
      }
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
      // return "container-chinese-card-mobile"
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    updateUser(path) {
      // let str = tempId.split("-");
      // let body = "/" + str[0] + "/" + str[1];
      // this.$store.commit("necessary/setCodePage", str[1]);
      // this.$store.dispatch('template/saveUserTemplateData', {
      //   code: this.courseCode,
      //   template: this.content._id,
      //   section:
      //     this.$store.getters['necessary/getLerningCourse'].groups[0].code,
      //   startTime: this.startTime,
      //   endTime: this.$helpers.getDateFormat(),
      //   condition: this.condition,
      // });

      const data = [
        {
          codeItem: this.v3Data.codeItem,
          courseId: this.$store.state.necessary.learningCourse,
          template: this.v3Data.templateID,
          section: this.$store.state.v3.v3EnrollData.data.section,
          content: this.v3Data.content,
          type: this.v3Data.type,
          answering: [],
          progress: 100,
          score: 0,
          maxScore: 0,
        },
      ];
      this.$store.dispatch('v3/saveContent', data);

      const next = this.navigate.action.split('-');
      const nextPath = `/v3/${next[0]}/${next[1]}`;

      this.$router.push(nextPath);
    },
    playSound(sound) {
      if (sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    },
    checkPicture() {
      var data = this.content.content.item[0].icon.enable.data;
      if (data === '/chinese/Image/ELEMENT/chest-open.png') {
        this.sound = '/chinese/Sound/Effect/Opening%20Chest/magic-wand.mp3';
        var sound = this.baseUrl + this.sound;
        this.playSound(sound);
      } else if (data === '/chinese/Image/ITEM/paperroll/treasure-open.png') {
        this.sound = '/chinese/Sound/Effect/Opening%20Chest/magic-wand.mp3';
        var sound = this.baseUrl + this.sound;
        this.playSound(sound);
      } else if (data === '/chinese/Image/ELEMENT/chest-closed.gif') {
        this.sound = '/chinese/Sound/Effect/Opening%20Chest/magic-wand.mp3';
        var sound = this.baseUrl + this.sound;
        this.playSound(sound);
      } else if (data === '/chinese/Image/CHARACTER/FINAL/pegion_new.png') {
        this.sound = '/chinese/Sound/Effect/short-pigeon-wing-flap.mp3';
        var sound = this.baseUrl + this.sound;
        this.playSound(sound);
      } else if (data === '/chinese/Image/ELEMENT/pegion_new.png') {
        this.sound = '/chinese/Sound/Effect/short-pigeon-wing-flap.mp3';
        var sound = this.baseUrl + this.sound;
        this.playSound(sound);
      }
    },
  },
};
</script>
<style></style>
